import { IsNotEmpty, IsUUID } from 'class-validator';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class UploadDocumentDto {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  eventId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  nodeId: string;

  attributes?: FormAttributesRequest;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  document: FileInputValue;

  documentDate?: string;

  documentNumber?: string;
}
